import axios from "../../../../../../api/axiosInstance";

export const deleteProductStoreProduct = async (id: string): Promise<void> => {
  await axios.delete(`/api/private/product-store/products/${id}`);
};
